var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    { class: _vm.$style.dialog, on: { cancel: _vm.$formCancelHandler } },
    [
      _c(
        "div",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [
          _vm.user.profilePicture
            ? _c("img", {
                class: _vm.$style.logo,
                attrs: { src: _vm.logo, alt: "User Image" },
              })
            : _c("div", { class: _vm.$style.logo }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
              ]),
          _c(
            "div",
            { class: _vm.$style.desc },
            [
              _c("div", { class: _vm.$style.name }, [
                _vm._v(" " + _vm._s(_vm.user.fullName) + " "),
              ]),
              _vm.currentUserIsAdmin && !_vm.isCurrentUser
                ? _c(
                    "dropdown-actions",
                    {
                      staticClass: "light",
                      class: _vm.$style.role,
                      attrs: { items: _vm.types },
                      model: {
                        value: _vm.userType,
                        callback: function ($$v) {
                          _vm.userType = $$v
                        },
                        expression: "userType",
                      },
                    },
                    [
                      _c("template", { slot: "value" }, [
                        _c("i", { staticClass: "material-icons active" }, [
                          _vm._v("account_circle"),
                        ]),
                        _vm._v(
                          " User Type - " +
                            _vm._s(_vm.userType && _vm.userType.label) +
                            " "
                        ),
                      ]),
                    ],
                    2
                  )
                : _c("div", { class: _vm.$style.inactiveRole }, [
                    _c("i", { staticClass: "material-icons active" }, [
                      _vm._v("account_circle"),
                    ]),
                    _vm._v(
                      " User Type - " +
                        _vm._s(_vm.userType && _vm.userType.label) +
                        " "
                    ),
                  ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c("div", { class: _vm.$style.listHead }, [
            _c("span", [
              _vm._v(
                " User is assigned to " +
                  _vm._s(_vm.accountsManaged.length) +
                  " " +
                  _vm._s(
                    _vm.accountsManaged.length > 1 ? "Companies" : "Company"
                  ) +
                  " "
              ),
            ]),
            _c("span", [_vm._v("User Assigned:")]),
          ]),
          _c(
            "div",
            { class: _vm.$style.companies },
            [
              _vm._l(_vm.companiesList, function ({ listAdded, list }) {
                return _vm._l(list, function (account, index) {
                  return _c(
                    "div",
                    {
                      key: account.id,
                      class: {
                        [_vm.$style.company]: true,
                        [_vm.$style.lastAdded]:
                          _vm.currentUserIsAdmin &&
                          listAdded &&
                          _vm.hasBothAddedAndNotAdded &&
                          index === list.length - 1,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggle(account)
                        },
                      },
                    },
                    [
                      _vm.currentUserIsAdmin
                        ? _c("check-box", {
                            attrs: {
                              value: _vm.added(account),
                              "check-box-value": true,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.toggle(account)
                              },
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                              },
                            },
                          })
                        : _vm._e(),
                      _c("div", { class: _vm.$style.name }, [
                        _vm._v(" " + _vm._s(account.name) + " "),
                      ]),
                      account.primaryAgent
                        ? [
                            account.primaryAgent.userDetails
                              ? _c("div", { class: _vm.$style.primary }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        account.primaryAgent.userDetails
                                          .fullName
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c("div", { class: _vm.$style.unAssigned }, [
                                  _vm._v(" Not Assigned "),
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("warning"),
                                  ]),
                                ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                })
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _vm.currentUserIsAdmin
            ? _c(
                "button",
                {
                  staticClass: "rbButton mainButton",
                  attrs: { disabled: !_vm.canSave, type: "button" },
                  on: { click: _vm.save },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("account_circle"),
                  ]),
                  _vm._v(" Apply Changes "),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }